export enum ImageSize {
  Logo = "logo",
  Thumb = "thumb",
  Regular = "regular",
  Full = "full",
}
